var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubtract2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 56,
    viewBox: "0 0 56 56",
    width: 56,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "path",
    d: "M37.9508 5.4492L45.9074 13.4059C46.3058 13.8042 46.5499 14.3813 46.5499 14.9567V49.0234C46.5499 50.2423 45.5522 51.24 44.3333 51.24H11.6666C10.4477 51.24 9.44992 50.2423 9.44992 49.0234V7.02337C9.44992 5.80447 10.4477 4.8067 11.6666 4.8067H36.3766C36.9768 4.8067 37.5301 5.02855 37.9508 5.4492ZM20.4166 44.45C20.8077 44.45 21.1166 44.1411 21.1166 43.75V35.5834C21.1166 35.1923 20.8077 34.8834 20.4166 34.8834H16.9166C16.5255 34.8834 16.2166 35.1923 16.2166 35.5834V43.75C16.2166 44.1411 16.5255 44.45 16.9166 44.45H20.4166ZM16.2166 16.3334C16.2166 18.9645 18.3688 21.1167 20.9999 21.1167C23.631 21.1167 25.7833 18.9645 25.7833 16.3334C25.7833 13.7023 23.631 11.55 20.9999 11.55C18.3688 11.55 16.2166 13.7023 16.2166 16.3334ZM29.7499 44.45C30.141 44.45 30.4499 44.1411 30.4499 43.75V30.9167C30.4499 30.5256 30.141 30.2167 29.7499 30.2167H26.2499C25.8588 30.2167 25.5499 30.5256 25.5499 30.9167V43.75C25.5499 44.1411 25.8588 44.45 26.2499 44.45H29.7499ZM39.0833 44.45C39.4744 44.45 39.7833 44.1411 39.7833 43.75V26.25C39.7833 25.8589 39.4744 25.55 39.0833 25.55H35.5833C35.1922 25.55 34.8833 25.8589 34.8833 26.25V43.75C34.8833 44.1411 35.1922 44.45 35.5833 44.45H39.0833Z",
    fill: "url(#paint0_linear_62_745)",
    stroke: "white",
    strokeWidth: 0.233333
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    className: "defs"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    className: "linear-gradient",
    gradientUnits: "userSpaceOnUse",
    id: "paint0_linear_62_745",
    x1: 27.9999,
    x2: 27.9999,
    y1: 4.69003,
    y2: 51.3567
  }, /*#__PURE__*/React.createElement("stop", {
    className: "stop",
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stop",
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract2);
export default __webpack_public_path__ + "static/media/subtract-2.4b6f496565bd673ef6a1268c898787fe.svg";
export { ForwardRef as ReactComponent };